import { createSelector } from '@reduxjs/toolkit';
import { useSelector } from 'react-redux';
import { TAppdata } from '../types';
import { RootState } from '../store';
import { selectPages } from '../store/selector/selectPages';
import { selectSettings } from '../store/selector/selectSettings';
import { pick } from 'lodash';
import * as defaults from '../store/saga/initial/constants';

const selectAppData = createSelector(
  [
    (state: RootState) => state.api['get-init-data']?.status || 'init',
    (state: RootState) => selectPages(state),
    (state: RootState) => selectSettings(state),
  ],
  (status, pages, settings) => {
    switch (status) {
      case 'rejected':
        return {
          status,
          settings: defaults.settings,
          pages: pick(defaults.pages, ['default-error']),
        };
      case 'succeed':
        return {
          status,
          settings: settings ||  defaults.settings,
          pages,
        };
      default:
        return {
          status,
          settings: defaults.settings,
          pages: pick(defaults.pages, ['default-initial']),
        };
    }
  }
);

export const useAppData = (): TAppdata => {
  return useSelector(selectAppData);
};
